// 年/季度/月份 枚举
export enum PeriodType {
  // 年份
  Year = 1,
  // 季度
  Quarter = 2,
  // 月份
  Month = 3,
  // 时间范围
  Range = 4,
}

// 订单/货运单/实收-统计类型
export enum StatisticsType {
  // 订单
  Order = '1',
  // 货运单
  Shipping = '2',
  // 实收
  Received = '3',
}

// 个人 - 机会项目阶段 Stage
export enum OpportunityProjectStage {
  // 新建
  New = 1,
  // 发现
  Discovery,
  // 建议
  Proposal,
  // 谈判
  Negotiation,
  // 赢单
  Won,
  // 采样
  Sampling,
  // 失败
  Lost,
}

export enum OrgTreeType {
  // 渠道组织维度
  Channel = 1,
  // 用户维度
  User = 2,
}

/*
* 渠道类型，用于区分当前这一个 Channel 是用户，渠道，还是用户底下的渠道
* 默认是 渠道
*/
export enum ChannelTypeEnum {
  // 渠道
  Channel = 1,
  // 用户
  User = 2,
  // 用户下的渠道
  ChannelInUser = 3,
  // 渠道下的用户
  UserInChannel = 4,
}
